import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { EmailValidationConfigService } from '../../Service/correo-validacion-config.service';
import { inject } from '@angular/core';

export function smartEmailValidator(): ValidatorFn {

  const configService = inject(EmailValidationConfigService);

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;

    const email = value.toString().trim().toLowerCase();

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      return { emailStructure: true };
    }

    const [, domain] = email.split('@');

    if (configService.invalidDomains.includes(domain)) {
      return { emailDomainTypo: true };
    }

    if (configService.invalidTlds.some(tld => domain.endsWith(tld))) {
      return { emailInvalidTld: true };
    }

    return null;
  };
}